/**
 * CloudPlatformChip component
 *
 * This component is used to display the cloud platform chip in components that e.g. list information on VMs or logs.
 */

import { Chip, Tooltip } from "@mui/material";
import { baseTheme } from "@app/theme";

interface IProps {
  cloudPlatform?: string | null | undefined;
  tooltipText?: string;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
  toolTipArrow?: boolean;
}

enum CloudPlatformColors {
  AZURE = "#0078D4",
  GCP = "#DB4437",
}

const getBackgroundColor = (cloudPlatform: string | null | undefined) => {
  if (!cloudPlatform) {
    return baseTheme.palette.secondary.light;
  }
  const colorKey =
    cloudPlatform.toUpperCase() as keyof typeof CloudPlatformColors;
  const color =
    CloudPlatformColors[colorKey] ?? baseTheme.palette.secondary.light;
  return color;
};

const CloudPlatformChip = (props: IProps) => {
  const { cloudPlatform, tooltipText, tooltipPlacement, toolTipArrow } = props;

  // If a tooltip text is provided, wrap the chip in a tooltip
  if (tooltipText) {
    return (
      <Tooltip
        title={tooltipText}
        placement={tooltipPlacement ?? "top"}
        arrow={toolTipArrow ?? true}
      >
        <Chip
          label={cloudPlatform ?? "N/A"}
          component={"span"}
          style={{
            // Set the background color based on the cloud platform
            background: getBackgroundColor(cloudPlatform),
            color: "#fff",
          }}
        />
      </Tooltip>
    );
  }
  return (
    <Chip
      label={cloudPlatform ?? "N/A"}
      component={"span"}
      style={{
        // Set the background color based on the cloud platform
        background: getBackgroundColor(cloudPlatform),
        color: "#fff",
      }}
    />
  );
};

export default CloudPlatformChip;
